import { render, staticRenderFns } from "./main-menu.vue?vue&type=template&id=2b545854&scoped=true&"
import script from "./main-menu.vue?vue&type=script&lang=ts&"
export * from "./main-menu.vue?vue&type=script&lang=ts&"
import style0 from "./main-menu.vue?vue&type=style&index=0&id=2b545854&prod&scoped=true&lang=less&"
import style1 from "./main-menu.vue?vue&type=style&index=1&id=2b545854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b545854",
  null
  
)

export default component.exports